// import {title} from "assets/jss/material-kit-react.jsx";
// import blueBG from "assets/img/blue_bg.png";

const disqusPollStyle = {
  section: {
    paddingTop: 100,
    paddingBottom: 100,
    // backgroundColor: "#fff",

    // backgroundImage: `url(${blueBG})`,
    // backgroundPosition: "0px 0px",
    // backgroundSize: 719,
    //
    // // backgroundImage: `url(${metaBG})`,
    // height: 450,
    // backgroundPosition: "50% 100%",
    // backgroundSize: "contain",
    // backgroundRepeat: "no-repeat",
  },
  imgPlaceHolder: {
    display: "block",
    marginRight: "auto",
    marginLeft: "auto",
  },
  commentHeader: {
    textAlign: 'center',
    marginBottom: 30,
  },
  comments: {
    display: "block",
    // boxShadow: "1px 1px 19px 0 rgba(0, 0, 0, .16)",
    // padding: 10,
    marginRight: "auto",
    marginLeft: "auto",
    width: "80%",
    scrollbarWidth: 'none', //Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome/Safari/Webkit
    },
  },
};

export default disqusPollStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/pollTemplateSections/disqusPollStyle.jsx